import {
  axiosInstance,
  GET_MATERIAL_FOLDER_URL,
  GET_MATERIALS_URL,
  GET_MATERIAL_INSTITUTION_FOLDER_URL,
  GET_MATERIALS_INSTITUTION_URL,
} from "../apiurls/apiurls";

export const getMaterialFolders = async ({ title, key }) => {
  try {
    const response = await axiosInstance.get(
      `${GET_MATERIAL_FOLDER_URL}?title=${encodeURIComponent(
        title
      )}&key=${encodeURIComponent(key || "")}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching material folders:", error);
    throw error;
  }
};

export const getMaterialsByFolder = async ({ folderId, page, limit }) => {
  try {
    const params = {
      materials_folders: folderId || "",
    };
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;
    const response = await axiosInstance.get(GET_MATERIALS_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching materials by folder:", error);
    throw error;
  }
};

export const getMaterialInstitutionFolders = async ({ title, key }) => {
  try {
    const response = await axiosInstance.get(
      `${GET_MATERIAL_INSTITUTION_FOLDER_URL}?title=${encodeURIComponent(
        title
      )}&key=${encodeURIComponent(key || "")}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching material institution folders:", error);
    throw error;
  }
};

export const getMaterialsInstitutionByFolder = async ({ folderId, page, limit }) => {
  try {
    const params = {
      materials_folders: folderId || "",
    };
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;
    const response = await axiosInstance.get(
      GET_MATERIALS_INSTITUTION_URL,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching materials institution by folder:", error);
    throw error;
  }
};
